
export class EventDocument {
  id?: number;
  eventId?: number;
  name?: string;
  path?: string;
}
